import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import preview from './outliersPreview.png';

export const outliersDescription: DropdownTooltipText = {
    body: (
        <>
            <div>Visualizes order performance versus a chosen benchmark.</div>
        </>
    ),
    minPreviewHeight: 180,
    previews: [
        {
            src: preview,
            altText: 'outliers-widget-preview',
        },
    ],
};
